import jwtDecode from "jwt-decode";
import BunkeyAPI from "../api/BunkeyAPI";
import appHistory from "../History";

import {
  LOGIN_USER,
  LOGIN_USER_SUCCESS,
  LOGIN_USER_FAILURE,
  LOGOUT_USER,
  RECOVERY_PASSWORD,
  RECOVERY_PASSWORD_SUCCESS,
  RECOVERY_PASSWORD_FAILURE,
  REFRESH_TOKEN,
  RESTART_RECOVERY,
  USER_CHANGE_PASSWORD,
  USER_CHANGE_PASSWORD_SUCCESS,
  USER_CHANGE_PASSWORD_FAILURE,
  USER_MODAL_NEWS,
  REFRESH_TOKEN_SUCCESS,
  REFRESH_TOKEN_FAILURE,
  USER_FORCE_PASSWORD_CHANGE,
  USER_SHOW_NOTIFICATION_ANIMATION,
  CLEAN_ERROR
} from "../constants/login-types";
import {
  ADVANCED_SEARCH_ENABLED,
  ADVANCED_SEARCH_VISIBLE
} from "../constants/app-types";
import {
  CLIENT_EMPTY,
  CLIENTS_EMPTY,
  CLIENT_UNSET_UPLOADING
} from "../constants/client-types";
import { SEARCH_EMPTY, SEARCH_ADVANCED_EMPTY } from "../constants/search-types";
import { ASSET_EXPLORE_EMPTY } from "../constants/assets-explore-types";
import { ASSET_ROOT_EMPTY } from "../constants/assets-root-types";
import { ASSET_SHARED_EMPTY } from "../constants/assets-share-types";
import { ASSET_FAVORITES_EMPTY } from "../constants/assets-favorites-types";
import { ASSET_LAST_UPLOAD_EMPTY } from "../constants/assets-lastupload-types";
import { USERS_EMPTY } from "../constants/users-types";
import { GROUP_EMPTY } from "../constants/group-types";
import { JOBS_EMPTY } from "../constants/job-types";
import { CLEAR_MENTIONS, COMMENT_EMPTY } from "../constants/comment-types";
import { NOTIFICATION_EMPTY } from "../constants/notification-types";
import { fetchAndSetAwsCredentials } from "../reducers/awsAuthActions"; // Added for AWS credentials
import { handleStatusSocket } from "./NotificationAction";
import { DOWNLOAD_EMPTY } from "../constants/download-types";
import {
  AVATAR_CONFIG,
  AVATAR_CONFIG_SUCCESS,
  AVATAR_CONFIG_FAILURE
} from "../constants/avatar-types";
import {
  COLOR_CHANGE,
  COLOR_CHANGE_SUCCESS,
  COLOR_CHANGE_FAILURE,
  COLOR_CHANGE_FORCE
} from "../constants/color-types";
import { handleUserAttemps, setNumberAttemps } from "../actions/ClientAction";
import Socket from "../utils/sockets";
import {
  handleShowProgressIndicator,
  handleMineOrAll
} from "../actions/DownloadAction";
import { COUNTRY_GET, COUNTRY_GET_FAILURE } from "../constants/country-codes";
import { sendNotification, VERSION } from "../utils";
import {
  TOURS_MENU_STATE,
  TOURS_DASHBOARD_STATE
} from "../constants/tours-types";

export const signin = user => {
  return dispatch => {
    dispatch({ type: LOGIN_USER });

    BunkeyAPI({
      url: "auth/sign-in",
      method: "POST",
      data: {
        email: user.email.replace(/\s/g, "").toLowerCase(),
        password: user.password
      }
    })
      .then(resp => {
        const token = resp.data;
        const accessToken = jwtDecode(token.accessToken);
        const date = new Date(0);
        date.setUTCSeconds(accessToken.exp);
        localStorage.setItem("version", VERSION);
        const newColor = accessToken.user.color;
        if (newColor) {
          const rootStyles = document.documentElement.style;
          localStorage.setItem("primaryColor", newColor);
          rootStyles.setProperty("--primary-color", newColor, "important");
        }
        dispatch({
          type: LOGIN_USER_SUCCESS,
          payload: {
            user: {
              ...accessToken.user,
              canPass: !user.fromSignUp
            },
            exp: {
              tick: accessToken.exp,
              date
            },
            token
          }
        });
        dispatch(fetchAndSetAwsCredentials());
      })
      .catch(err => {
        dispatch({ type: LOGIN_USER_FAILURE, payload: err });
      });
  };
};
export const signUpFreeUser = user => {
  return dispatch => {
    dispatch({ type: LOGIN_USER });

    const phone = `${user.phoneCode}${user.phoneNumber}`;

    BunkeyAPI({
      url: "clients/signupFreeClient",
      method: "POST",
      data: {
        agent: user.name,
        name: user.agent,
        phone: phone,
        email: user.email,
        businessType: user.serviceSelected
      }
    })
      .then(resp => {
        const token = resp.data;
        const accessToken = jwtDecode(token.accessToken);
        const date = new Date(0);
        date.setUTCSeconds(accessToken.exp);
      })
      .catch(err => { });
  };
};

export const logout = (history, isCustom = false) => dispatch => {
  dispatch({ type: CLIENT_EMPTY });
  dispatch({ type: CLIENTS_EMPTY });
  dispatch({ type: SEARCH_EMPTY });
  dispatch({ type: CLIENT_UNSET_UPLOADING });
  dispatch({ type: NOTIFICATION_EMPTY });
  dispatch({ type: ASSET_EXPLORE_EMPTY });
  dispatch({ type: ASSET_ROOT_EMPTY });
  dispatch({ type: ASSET_SHARED_EMPTY });
  dispatch({ type: ASSET_FAVORITES_EMPTY });
  dispatch({ type: ASSET_LAST_UPLOAD_EMPTY });
  dispatch({ type: GROUP_EMPTY });
  dispatch({ type: USERS_EMPTY });
  dispatch({ type: JOBS_EMPTY });
  dispatch({ type: COMMENT_EMPTY });
  dispatch({ type: LOGOUT_USER });
  dispatch({ type: DOWNLOAD_EMPTY });
  dispatch({ type: CLEAR_MENTIONS });
  dispatch({ type: ADVANCED_SEARCH_ENABLED, payload: false });
  dispatch({ type: ADVANCED_SEARCH_VISIBLE, payload: true });
  dispatch({ type: SEARCH_ADVANCED_EMPTY });
  dispatch(handleUserAttemps([]));
  dispatch(setNumberAttemps(0));
  dispatch(handleStatusSocket(false));
  // Socket.disconnect()
  Socket.getInstance().close();
  dispatch(handleShowProgressIndicator(false));
  dispatch(handleMineOrAll(true));
  dispatch({ type: TOURS_MENU_STATE, payload: false });
  dispatch({ type: TOURS_DASHBOARD_STATE, payload: false });
  localStorage.clear();
  const rootStyles = document.documentElement.style;
  rootStyles.setProperty("--primary-color", "#3598CD", "important");
  if (history && !isCustom) {
    history.push("/");
  } else {
    appHistory.push("/");
  }
};

export const recoveryPassword = (intl, email) => {
  return dispatch => {
    dispatch({ type: RECOVERY_PASSWORD });
    BunkeyAPI({
      url: "recovery-password",
      method: "POST",
      data: {
        email: email.replace(/\s/g, "").toLowerCase()
      }
    })
      .then(resp => {
        if (resp.data === "notFound") {
          dispatch({
            type: RECOVERY_PASSWORD_FAILURE,
            payload: {
              resp: resp
            }
          });
        } else {
          dispatch({
            type: RECOVERY_PASSWORD_SUCCESS,
            payload: {
              resp: resp
            }
          });
          sendNotification(
            "success",
            intl,
            intl.formatMessage({ id: "notification-password-send-success" })
          );
        }
      })
      .catch(err => {
        dispatch({
          type: RECOVERY_PASSWORD_FAILURE,
          payload: err
        });
        sendNotification(
          "error",
          intl,
          intl.formatMessage({ id: "notification-password-send-error" })
        );
      });
  };
};

export const refreshToken = refreshToken => {
  return dispatch => {
    dispatch({ type: REFRESH_TOKEN });
    BunkeyAPI({
      url: `/auth/refresh-token`,
      method: "POST",
      data: {
        refreshToken: refreshToken
      }
    })
      .then(response => {
        const token = response.data;
        const accessToken = jwtDecode(token.accessToken);
        const date = new Date(0);
        date.setUTCSeconds(accessToken.exp);
        dispatch({
          type: REFRESH_TOKEN_SUCCESS,
          payload: {
            exp: {
              tick: accessToken.exp,
              date
            },
            token
          }
        });
      })
      .catch(err => {
        dispatch({
          type: REFRESH_TOKEN_FAILURE,
          payload: err
        });
      });
  };
};

export const restartRecovery = () => {
  return dispatch => {
    dispatch({ type: RESTART_RECOVERY });
  };
};

export const userChangePassword = (name, password) => {
  return dispatch => {
    dispatch({ type: USER_CHANGE_PASSWORD });

    BunkeyAPI({
      url: `users/me`,
      method: "PUT",
      data: {
        password,
        name
      }
    })
      .then(resp => {
        dispatch({
          type: USER_CHANGE_PASSWORD_SUCCESS,
          payload: name
        });
      })
      .catch(err => {
        dispatch({ type: USER_CHANGE_PASSWORD_FAILURE });
      });
  };
};

export const userAvatarConfig = futureFileURL => {
  return dispatch => {
    dispatch({ type: AVATAR_CONFIG });

    BunkeyAPI({
      url: "users/me",
      method: "PUT",
      data: {
        avatar: futureFileURL
      }
    })
      .then(resp => {
        dispatch(getUserMe());
      })
      .catch(err => {
        dispatch({
          type: AVATAR_CONFIG_FAILURE,
          payload: err
        });
      });
  };
};

export const getUserMe = () => {
  return dispatch => {
    BunkeyAPI({
      url: "users/me",
      method: "GET"
    })
      .then(resp => {
        dispatch({
          type: AVATAR_CONFIG_SUCCESS,
          payload: resp.data.avatar
        });
      })
      .catch(err => {
        dispatch({
          type: AVATAR_CONFIG_FAILURE,
          payload: err
        });
      });
  };
};

export const userColorChange = colorState => {
  return dispatch => {
    dispatch({ type: COLOR_CHANGE });
    BunkeyAPI({
      url: "users/me",
      method: "PUT",
      data: {
        color: colorState
      }
    })
      .then(resp => {
        dispatch(getColor());
      })
      .catch(err => {
        dispatch({
          type: COLOR_CHANGE_FAILURE,
          payload: err
        });
      });
  };
};

export const getColor = () => {
  return dispatch => {
    BunkeyAPI({
      url: "users/me",
      method: "GET"
    })
      .then(resp => {
        dispatch({
          type: COLOR_CHANGE_SUCCESS,
          payload: resp.data.color
        });
      })
      .catch(err => {
        dispatch({
          type: COLOR_CHANGE_FAILURE,
          payload: err
        });
      });
  };
};

export const forceColor = color => {
  const rootStyles = document.documentElement.style;
  localStorage.setItem("primaryColor", color);
  rootStyles.setProperty("--primary-color", color, "important");
  return dispatch =>
    dispatch({
      type: COLOR_CHANGE_FORCE,
      payload: color
    });
};

export const editShowModalNews = show => {
  return dispatch => {
    dispatch({
      type: USER_MODAL_NEWS,
      payload: show
    });
  };
};

export const setForcePasswordChange = value => {
  return dispatch => {
    dispatch({
      type: USER_FORCE_PASSWORD_CHANGE,
      payload: value
    });
  };
};

export const setNotificationAnimation = value => {
  return dispatch => {
    BunkeyAPI({
      url: `/users/me/checkNotificationAnimation`,
      method: "PUT"
    })
      .then(resp => {
        if (resp.status === 200) {
          dispatch({
            type: USER_SHOW_NOTIFICATION_ANIMATION,
            payload: value
          });
        }
      })
      .catch(err => { });
  };
};

export const getCountryCodes = () => {
  return dispatch => {
    fetch(
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/index.json"
    )
      .then(response => response.json())
      .then(dataCountries => {
        fetch(
          "https://gist.githubusercontent.com/anubhavshrimal/75f6183458db8c453306f93521e93d37/raw/f77e7598a8503f1f70528ae1cbf9f66755698a16/CountryCodes.json"
        )
          .then(response => response.json())
          .then(data => {
            const dataFormat = dataCountries.reduce(function (filtered, item) {
              const exist = data.find(x => x.code === item.code);
              if (exist) {
                filtered.push({
                  ...item,
                  dial_code: exist ? exist.dial_code : ""
                });
              }
              return filtered;
            }, []);
            const uniqueDialCodes = dataFormat.reduce((acc, item) => {
              if (!acc.includes(item.dial_code)) {
                acc.push(item.dial_code);
              }
              return acc;
            }, []);
            const uniqueCountries = uniqueDialCodes.map(value => {
              return dataFormat.filter(item => item.dial_code === value)[0];
            });
            uniqueCountries.sort((a, b) => {
              const nameA = a.name.toLowerCase();
              const nameB = b.name.toLowerCase();

              if (nameA < nameB) {
                return -1;
              }
              if (nameA > nameB) {
                return 1;
              }
              return 0;
            });
            dispatch({
              type: COUNTRY_GET,
              payload: uniqueCountries
            });
          })
          .catch(err => {
            dispatch({
              type: COUNTRY_GET_FAILURE,
              payload: err
            });
          });
      })
      .catch(err => {
        dispatch({
          type: COUNTRY_GET_FAILURE,
          payload: err
        });
      });
  };
};

export const cleanErrorMessage = () => {
  return dispatch => {
    dispatch({
      type: CLEAN_ERROR,
      payload: {}
    });
  };
};
